import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export enum ChecklistValidationErrors {
  INTERVALS_EMPTY = 'intervalsEmpty',
  INVALID_INTERVALS = 'invalidIntervals',
  DUPLICATE_INTERVALS = 'duplicateIntervals',
  ROWS_EMPTY = 'checklistRowsEmpty',
  BUILDINGS_EMPTY = 'checklistBuildingsEmpty',
}

@Injectable({
  providedIn: 'root',
})
export class ChecklistValidationService {
  calendarWeeksValidator = (): ValidatorFn => {
    return (control: AbstractControl): ValidationErrors | null => {
      const checklist = control.value;

      if (control?.pristine) return null;

      if (checklist.length === 0) {
        return {
          [ChecklistValidationErrors.INTERVALS_EMPTY]: {
            message: 'ROUND_PLANNING_CHECKLIST_FORM.INTERVALS_VALIDATION_MSG_EMPTY',
            params: {},
          },
        };
      }

      const invalidValues: number[] = [];
      checklist.forEach((x: number) => {
        if (isNaN(x) || x < 1 || x > 53) {
          invalidValues.push(x);
        }
      });

      if (invalidValues.length > 0) {
        return {
          [ChecklistValidationErrors.INVALID_INTERVALS]: {
            message: 'ROUND_PLANNING_CHECKLIST_FORM.INTERVALS_VALIDATION_MSG',
            params: { invalidValues },
          },
        };
      }

      const duplicates = checklist.filter((item: number, index: number, arr: number[]) => arr.indexOf(item) !== index);

      if (duplicates.length > 0) {
        return {
          [ChecklistValidationErrors.DUPLICATE_INTERVALS]: {
            message: 'ROUND_PLANNING_CHECKLIST_FORM.INTERVALS_VALIDATION_MSG_DUPLICATES',
            params: { duplicates },
          },
        };
      }

      return null; // Validation passes
    };
  };

  checklistRowsValidator = (): ValidatorFn => {
    return (control: AbstractControl): ValidationErrors | null => {
      const checklistRows = control.value;

      if (checklistRows.length === 0) {
        return {
          [ChecklistValidationErrors.ROWS_EMPTY]: {
            message: 'ROUND_PLANNING_CHECKLIST_FORM.CHECKPOINTS_EMPTY',
            params: {},
          },
        };
      }

      return null;
    };
  };

  checklistBuildingValidator = (): ValidatorFn => {
    return (control: AbstractControl): ValidationErrors | null => {
      const buildings = control.value as string[] | null | undefined;

      if (!buildings?.length) {
        return {
          [ChecklistValidationErrors.BUILDINGS_EMPTY]: {
            message: 'ROUND_PLANNING_CHECKLIST_FORM.BUILDINGS_VALIDATION_MSG',
            params: {},
          },
        };
      }

      return null;
    };
  };
}
